/* @flow */
import React from 'react';
import gql from 'graphql-tag';
import {DestinationMessage as DestinationMessageComponent} from '@homeaway/react-urgency-messaging';

import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';

export const fragments = {
    results: gql`
        fragment DestinationMessageResults on Results {
            destinationMessage {
                iconTitleText {
                    title
                    message
                    icon
                }
                iconText {
                    message
                    icon
                }
            }
        }
    `
};

export function Content(destinationMessage: DestinationMessage) {
    return (
        <DestinationMessageComponent
            destinationMessage={destinationMessage}
            size={'l'}
            ariaHidden
        />
    );
}
